module.exports = __webpack_public_path__ + "023daa710a177abe0514e464bf9e99e8.webm";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Message/videos/marc-amalia-cut.webm
 ** module id = 353
 ** module chunks = 0
 **/